const sectionTableSmallB1Css = `
[data-type='section-table-small-b1'] .wrapper-container {
  color: var(--text-color, #000000);
}

[data-type='section-table-small-b1'] .wrapper-container[data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-table-small-b1'] .wrapper-container[data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-table-small-b1'] .wrap-content {
  max-width: 832px;
  margin: 0 auto;
}

[data-type='section-table-small-b1'] .wrap-content .table-area .table-add {
  overflow-x: auto;
  overflow-y: hidden;
}

[data-type='section-table-small-b1'] .wrap-content .table-area .table-add[data-col-border='true'] table {
  width: 100%;
  text-align: left;
}

[data-type='section-table-small-b1'] .wrap-content .table-area .table-add[data-col-border='true'] table td,
[data-type='section-table-small-b1'] .wrap-content .table-area .table-add[data-col-border='true'] table th {
  border: solid var(--border-weight, 1px) var(--border-color, #c1c1c1);
}

[data-type='section-table-small-b1'] .wrap-content .table-area .table-add[data-row-border='true'] table {
  width: 100%;
  text-align: left;
}

[data-type='section-table-small-b1'] .wrap-content .table-area .table-add[data-row-border='true'] table tr {
  border-bottom: solid var(--border-weight, 1px) var(--border-color, #c1c1c1);
}

[data-type='section-table-small-b1'] .wrap-content .table-area .table-add table {
  border-collapse: collapse;
  margin: 0 auto;
}

[data-type='section-table-small-b1'] .wrap-content .table-area .table-add table tr th {
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

[data-type='section-table-small-b1'] .wrap-content .table-area table {
  border-spacing: var(--border-spacing-vertical, 0px) var(--border-spacing-horizontal, 0px);
}

[data-type='section-table-small-b1'] .title-content {
  margin-bottom: 40px;
}

[data-type='section-table-small-b1'] .title-content h1,
[data-type='section-table-small-b1'] .title-content h2,
[data-type='section-table-small-b1'] .title-content h3,
[data-type='section-table-small-b1'] .title-content h4 {
  font-size: 24px;
  margin: 0 0 16px 0 !important;
}

[data-type='section-table-small-b1'] .title-content h1 p,
[data-type='section-table-small-b1'] .title-content h2 p,
[data-type='section-table-small-b1'] .title-content h3 p,
[data-type='section-table-small-b1'] .title-content h4 p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

@container (max-width: 768px) {
  [data-type='section-table-small-b1'] .wrapper-container[data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-table-small-b1'] .wrapper-container[data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-table-small-b1'] .title-content h1,
  [data-type='section-table-small-b1'] .title-content h2,
  [data-type='section-table-small-b1'] .title-content h3,
  [data-type='section-table-small-b1'] .title-content h4 {
    font-size: 20px;
    margin: 0 0 12px 0 !important;
  }

  [data-type='section-table-small-b1'] .title-content h1 p,
  [data-type='section-table-small-b1'] .title-content h2 p,
  [data-type='section-table-small-b1'] .title-content h3 p,
  [data-type='section-table-small-b1'] .title-content h4 p {
    font-size: 14px;
  }
}
`;
export default sectionTableSmallB1Css;
